import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Button = ({
  type,
  style,
  size,
  width,
  iconRight,
  iconLeft,
  label,
  redirect,
  disabled,
  onClick,
  classNames,
}) => {
  const button = (
    <button
      className={cn(classNames, style, size, width)}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {iconLeft}
      {label && <div className="beta-btn__label-wrapper">{label}</div>}
      {iconRight}
    </button>
  );

  const link = (
    <a href={redirect} className={`${style} ${size} ${width}`}>
      {iconLeft}
      {label && <div className="beta-btn__label-wrapper">{label}</div>}
      {iconRight}
    </a>
  );

  return redirect ? link : button;
};

export const ButtonStyles = {
  primary: 'beta-btn beta-btn--primary',
  secondary: 'beta-btn beta-btn--secondary',
  destructive: 'beta-btn beta-btn--destructive',
  empty: 'beta-btn beta-btn--empty',
  ghost: 'beta-btn beta-btn--ghost',
  tonal: 'beta-btn beta-btn--tonal',
  chipSuggestion: 'beta-btn beta-btn--chip-suggestion',
  chipSuggestionSelected:
    'beta-btn beta-btn--chip-suggestion beta-btn--chip-suggestion--selected',
  text: 'beta-btn beta-btn--text',
  textUnderlined: 'beta-btn beta-btn--text beta-btn--text--underlined',
  textUnderlinedAlways:
    'beta-btn beta-btn--text beta-btn--text--underlined-always',
  textDestructive: 'beta-btn beta-btn--text beta-btn--text--destructive',
  textInvert: 'beta-btn beta-btn--text-invert',
  textInvertUnderlined:
    'beta-btn beta-btn--text-invert beta-btn--text-invert--underlined',
  textInvertUnderlinedAlways:
    'beta-btn beta-btn--text-invert beta-btn--text-invert--underlined-always',
  icon: 'beta-btn beta-btn--icon',
  showMoreToggle: 'beta-btn beta-btn--show-more-toggle',
};

export const ButtonSizes = {
  xxs: 'beta-btn--xxs',
  xs: 'beta-btn--xs',
  s: 'beta-btn--s',
  m: 'beta-btn--m',
  l: 'beta-btn--l',
};

export const ButtonWidths = {
  isFull: 'beta-btn--full',
  auto: '',
};

Button.defaultProps = {
  type: 'button',
  style: ButtonStyles.primary,
  size: ButtonSizes.s,
  width: ButtonWidths.auto,
  disabled: false,
  classNames: null,
};

Button.propTypes = {
  style: PropTypes.oneOf(Object.values(ButtonStyles)),
  size: PropTypes.oneOf(Object.values(ButtonSizes)),
  width: PropTypes.oneOf(Object.values(ButtonWidths)),
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]),
  iconLeft: PropTypes.node,
  iconRight: PropTypes.node,
  text: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  redirect: PropTypes.string,
  type: PropTypes.string,
  classNames: PropTypes.string,
};

export default Button;
